var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"mt-1 whitespace-no-wrap"},[_vm._v(_vm._s(_vm.elapsedTime(_vm.date)))])
}
var staticRenderFns = []

export { render, staticRenderFns }